import { Box, Stack } from '@mui/material';
import { MenuItem } from 'generated/graphql';
import { ItemLink } from '../../ItemLink';
import { LevelThreeGrid } from '../../LevelThreeGrid';
import { LevelThreeBackButton } from '../../LevelThreeBackButton';
import { LevelFourLink } from './LevelFourLink';

type LevelThreeLinksProps = {
    listItem: MenuItem;
    closeSubMenu: () => void;
};

export function LevelThreeLinks({ listItem, closeSubMenu }: LevelThreeLinksProps) {
    return (
        <Box sx={{
            display: 'flex',
            columnGap: 2,
        }}
        >
            <LevelThreeBackButton onClick={closeSubMenu} />
            <Box sx={{ padding: 4 }}>
                <ItemLink
                    item={listItem}
                />
            </Box>
            <LevelThreeGrid
                columnWidth={280}
                maxWidth={800}
                rowGap={1}
                rows={5}
            >
                {listItem.items.map((item, itemIndex) => {
                    const isParent = item.items.length > 0;

                    return (
                        <Stack key={itemIndex}>
                            <ItemLink
                                item={item}
                                typographyProps={{ fontWeight: isParent ? 400 : 300 }}
                            />
                            {item.items.map((subItem, subItemIndex) => (
                                <LevelFourLink
                                    item={subItem}
                                    key={subItemIndex}
                                />
                            ))}
                        </Stack>
                    );
                })}
            </LevelThreeGrid>
        </Box>
    );
}
